import { render, staticRenderFns } from "./FacilityDeleteModal.vue?vue&type=template&id=f689a85e&scoped=true&"
import script from "./FacilityDeleteModal.vue?vue&type=script&lang=js&"
export * from "./FacilityDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f689a85e",
  null
  
)

export default component.exports